
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.195 46.39H35.637c-.29 0-.56-.119-.75-.338a.983.983 0 01-.24-.786c.29-2.25.4-4.222.4-7.288V27.913c0-1.882-.19-2.46-.62-3.047-.46-.617-1.37-.965-2.54-.965-2.42 0-4.63 1.493-6.569 4.45v9.627c0 2.877.11 4.858.4 7.298.03.278-.06.567-.25.776-.19.21-.46.339-.75.339H14.2c-.29 0-.56-.12-.75-.339a.983.983 0 01-.24-.786c.29-2.19.4-4.162.4-7.288V22.845c0-3.444-.11-5.416-.39-7.267a.998.998 0 01.99-1.145h10.108a1 1 0 011 .995v1.265c2.82-2.091 5.74-3.007 9.409-3.007 3.75 0 6.819 1.045 8.878 3.037 2.24 2.17 3.2 4.848 3.2 8.97v12.325c0 2.658.13 5.097.4 7.248a.961.961 0 01-.24.776 1.03 1.03 0 01-.77.349zm-9.439-1.99h8.32a65.873 65.873 0 01-.29-6.372V25.703c0-3.575-.75-5.755-2.59-7.537-1.67-1.613-4.26-2.469-7.48-2.469-3.929 0-6.768 1.135-9.788 3.913a.999.999 0 01-1.08.179c-.36-.16-.6-.518-.6-.916 0-.19.01-.488.03-.787.01-.238.02-.457.02-.587v-1.065H15.33c.19 1.652.26 3.544.26 6.421v15.133c0 2.678-.08 4.55-.28 6.421h8.268c-.21-2.04-.29-3.932-.29-6.421v-9.926c0-.19.05-.368.16-.527 2.37-3.734 5.2-5.625 8.41-5.625 1.819 0 3.299.627 4.149 1.772.77 1.045 1.01 2.07 1.01 4.23v10.066c.02 2.648-.06 4.52-.26 6.421z"}})])
          )
        }
      }
    